


// Generated from io.spcfy.orders.persistence.RedlistMode

export type RedlistModeKey =
  "NONE" |
  "DE" |
  "LOWER_SAXONY";


export interface RedlistModeDTO {
  key: RedlistModeKey;
  label: string;    
}


export const RedlistModes: Record<RedlistModeKey, RedlistModeDTO> = {
  NONE: { key: "NONE", label: "None" },
  DE: { key: "DE", label: "German Redlist" },
  LOWER_SAXONY: { key: "LOWER_SAXONY", label: "Redlist Lower Saxony" }
};
